import React from "react";
import EmptyTableMessage from "../../../components/table/EmptyTableMessage.js";
import { Link } from "react-router-dom";
import { formatCurrency } from "../../../utils/utils_number.js";
import { useTiposDte } from "../../../hooks_cache/useTiposDte";
import StatusBadge from "../../../components/StatusBadge";

const ComprobantesRelacionados = ({ comprobantesRelacionados }) => {
  const { data: tiposDte } = useTiposDte();
  return (
    <div>
      <h3>Comprobantes Relacionados:</h3>
      <div className="table-responsive shadow">
        <table className="table table-thead-sticky table-tfoot-sticky table-tbody-bordered table-px-10px table-py-4px table-sm table-striped text-nowrap mb-0">
          <thead>
            <tr className="text-nowrap">
              <th>#</th>
              <th>FECHA</th>
              <th>TIPO DTE</th>
              <th>CODIGO GENERACION</th>
              <th>MONTO</th>
              <th>ESTADO</th>
            </tr>
          </thead>
          <tbody>
            {comprobantesRelacionados?.length > 0 ? (
              comprobantesRelacionados.map((cp, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{cp.fecEmi}</td>
                  <td>{tiposDte?.find((t) => t.id === cp.id_tipoDTE)?.descripcion || "N/A"}</td>
                  <td>
                    <Link to={`/venta/comprobante/${cp.id}`} className="fw-bold text-nowrap">
                      {cp.codigoGeneracion}
                    </Link>
                  </td>

                  <td>{formatCurrency(cp.montoTotalOperacion)}</td>
                  <td>
                    <StatusBadge estado={cp.estado} size="" />
                  </td>
                </tr>
              ))
            ) : (
              <>
                <EmptyTableMessage columns={5} />
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComprobantesRelacionados;
